import React from 'react';
import { Clock, Save } from 'lucide-react';
import { WEEKDAYS_LONG } from './constants';

const BusinessHoursTab = ({ hours, onUpdateHour, onSave, saving, message }) => (
  <div className="bg-white border border-black/5 p-6" data-testid="business-hours-tab">
    <div className="flex items-center gap-2 mb-3">
      <Clock size={18} className="text-[#c9a961]" strokeWidth={1.5} />
      <h3 className="font-serif text-xl text-[#1c1e20]" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
        Business hours per weekday
      </h3>
    </div>
    <p className="text-[13px] text-[#6b6b6b] mb-5">
      Set different opening and closing times for each day. Clients can only pick time windows that fall within your hours.
    </p>
    <div className="overflow-x-auto">
      <table className="w-full text-[13px]">
        <thead>
          <tr className="text-left text-[10px] tracking-[0.22em] text-[#6b6b6b] border-b border-black/10">
            <th className="px-3 py-3 font-semibold">DAY</th>
            <th className="px-3 py-3 font-semibold">OPEN</th>
            <th className="px-3 py-3 font-semibold">CLOSE</th>
            <th className="px-3 py-3 font-semibold">CLOSED?</th>
          </tr>
        </thead>
        <tbody>
          {WEEKDAYS_LONG.map((label, wd) => {
            const h = hours.find((x) => x.weekday === wd) || { open: '07:00', close: '20:00', closed: false };
            return (
              <tr key={wd} className="border-b border-black/5">
                <td className="px-3 py-3 font-semibold text-[#1c1e20]">{label}</td>
                <td className="px-3 py-2">
                  <input
                    type="time"
                    value={h.open}
                    onChange={(e) => onUpdateHour(wd, 'open', e.target.value)}
                    disabled={h.closed}
                    data-testid={`hours-open-${wd}`}
                    className="border border-black/15 px-3 py-2 focus:outline-none focus:border-[#c9a961] disabled:bg-black/5 disabled:text-black/40"
                  />
                </td>
                <td className="px-3 py-2">
                  <input
                    type="time"
                    value={h.close}
                    onChange={(e) => onUpdateHour(wd, 'close', e.target.value)}
                    disabled={h.closed}
                    data-testid={`hours-close-${wd}`}
                    className="border border-black/15 px-3 py-2 focus:outline-none focus:border-[#c9a961] disabled:bg-black/5 disabled:text-black/40"
                  />
                </td>
                <td className="px-3 py-2">
                  <label className="inline-flex items-center gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={!!h.closed}
                      onChange={(e) => onUpdateHour(wd, 'closed', e.target.checked)}
                      data-testid={`hours-closed-${wd}`}
                      className="w-4 h-4 accent-[#c9a961]"
                    />
                    <span className="text-[#6b6b6b] text-[12px]">Closed all day</span>
                  </label>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
    <div className="mt-6 flex items-center justify-between">
      <p className="text-[12px] text-[#6b6b6b]">
        Time windows &middot; morning 7–10, midday 10–13, afternoon 13–17, evening 17–20
      </p>
      <div className="flex items-center gap-3">
        {message && <span className="text-[12px] text-[#8a7132]" data-testid="hours-save-message">{message}</span>}
        <button
          onClick={onSave}
          disabled={saving}
          data-testid="hours-save-button"
          className="flex items-center gap-2 bg-[#c9a961] hover:bg-[#b89751] text-[#141618] tracking-[0.22em] text-[11px] font-semibold px-6 py-2.5 disabled:opacity-60"
        >
          <Save size={13} /> {saving ? 'SAVING…' : 'SAVE HOURS'}
        </button>
      </div>
    </div>
  </div>
);

export default BusinessHoursTab;
